/* @flow */

import { fetchGraphql } from '../utils/ajax';
import type { GraphqlRequest, CallApi } from '../utils/ajax';

export type State = { isFetching: bool, items: any}
export type Action = { type: string, payload: {data: any} }

export let QUICKSEARCH_REQUEST = 'gdc/QUICKSEARCH_REQUEST';
export let QUICKSEARCH_SUCCESS = 'gdc/QUICKSEARCH_SUCCESS';
export let QUICKSEARCH_FAILURE = 'gdc/QUICKSEARCH_FAILURE';
export let QUICKSEARCH_CLEAR = 'gdc/QUICKSEARCH_CLEAR';

function queryNodes({
  first,
  offset,
  projectId,
  quickSearch,
  id,
  program,
  project,
  entityTypes
}): GraphqlRequest {
  return {
    variables: {
      first,
      offset,
      projectId: project ? `${program}-${project}` : null,
      quickSearch,
      id: id ? parseInt(id, 10) : null,
    },
    query:
      `query quickSearchQuery (
        $first: Int
        $offset: Int
        $projectId: String
        $quickSearch: String
        $id: String
    ) {
      items: node(id: $id
      project_id: $projectId
      quick_search: $quickSearch
      of_type: ${'["' + entityTypes.join('","') + '"]'}
      first: $first
      offset: $offset ) {
      id project_id type
      ${entityTypes.map(type => '...on ' + type + '{ submitter_id }')}
      }
    }`
  };
}

export function fetchQuickSearch(variables: any): CallApi {
  return fetchGraphql(
    [QUICKSEARCH_REQUEST, QUICKSEARCH_SUCCESS, QUICKSEARCH_FAILURE],
    queryNodes(variables)
  );
}

export default function reducer(state: State = {
  isFetching: false,
  items: []
}, action: Action): State {
  switch (action.type) {
  case QUICKSEARCH_REQUEST:
    return {
      ...state,
      isFetching: true
    };
  case QUICKSEARCH_CLEAR:
  case QUICKSEARCH_SUCCESS:
    return {
      ...state,
      isFetching: false,
      items: action.payload.data.items
    };
  case QUICKSEARCH_FAILURE:
    return {
      ...state,
      isFetching: false
    };
  default:
    return state;
  }
}

export function clearSearch(): Action {
  return {
    type: QUICKSEARCH_CLEAR,
    payload: { data: {items: []}}
  };
}
